import { put, select } from 'redux-saga/effects';

import * as actions from '../../actions';

import duplicateQuestion from './duplicateQuestion';
import updateDecisionFramework from '../updateDecisionFramework/updateDecisionFramework';
import executeRequestsInSequence from '../../helpers/executeRequestsInSequence';
import surveyPermissionsCharge from '../../../helpers/surveyPermissionsCharge';

export default function*(action) {
  const surveysState = yield select(state => state.surveys);
  const authState = yield select(state => state.auth);

  let newState = { ...surveysState };
  let frameworkRequests = [];

  if (surveysState.activeFlow && !surveysState.activeFlow.flows) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api('updateQuestion', newSurveyStateActiveFlow);

    if (
      surveysState.activeFlow.matrix &&
      surveysState.activeFlow.matrix.decisionFrameworkType
    ) {
      const {
        surveyWithUpdatedFramework,
        updateRequest
      } = updateDecisionFramework(surveysState.survey, surveysState.activeFlow);
      if (surveyWithUpdatedFramework) {
        newState = {
          ...newState,
          survey: surveyWithUpdatedFramework
        };
        if (updateRequest) {
          frameworkRequests = [updateRequest];
        }
      }
    }
  }

  newState = duplicateQuestion(
    newState,
    action.flow,
    action.destinationPosition,
    action.destinationQuestionId,
    action.newQuestionId
  );

  if (
    (newState.requests && newState.requests.length) ||
    frameworkRequests.length
  ) {
    frameworkRequests = [
      ...frameworkRequests,
      ...(newState.requests && newState.requests.length
        ? newState.requests
        : [])
    ];
    yield executeRequestsInSequence(action.api, frameworkRequests);
  }

  // Account management warnings
  const newPermissionsStateData = surveyPermissionsCharge(authState, newState);
  if (newPermissionsStateData) {
    newState.newState = {
      ...newState.newState,
      ...newPermissionsStateData
    };
  }

  yield put({ type: actions.SET_NEW_STATE, newState: newState.newState });

  // Add new question
  action.api('addQuestions', {
    questionsArray: [newState.duplicatedQuestion],
    surveyContent: newState.newState.survey.content
  });
}
